import { useDispatch, useSelector } from "react-redux";
import { formatCurrency, formatDate } from "../../../helpers/helpers";
import { GLOBAL_CONSTANTS } from "../../../constants/constants";
import { Typography, Table } from "antd";
import { getUnassignedTxn, getSettledDeals } from "../../../redux/slices/SettlementSlice";
import { useEffect, useMemo } from "react";
import { TABLE_PAGINATION } from "../../../constants/tableConfig";

const { Text } = Typography;

const unassignedCols = [
    {
        title: "Transaction Id",
        dataIndex: "txnId",
        key: "txnId",
        fixed: "left",
        width: 200,
        render: (text) => <Text style={{ fontSize: 14 }}>{text || GLOBAL_CONSTANTS.NA}</Text>,
    },
    {
        title: "UTR Number",
        dataIndex: "utr",
        key: "utr",
        fixed: "left",
        width: 200,
        render: (text) => <Text style={{ fontSize: 14 }}>{text || GLOBAL_CONSTANTS.NA}</Text>,
    },
    {
        title: "Credited date",
        dataIndex: "txnDate",
        key: "txnDate",
        width: 150,
        render: (text) => <Text style={{ fontSize: 14 }}>{formatDate(text) || GLOBAL_CONSTANTS.NA}</Text>,
    },
    {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        width: 150,
        render: (text) => <Text style={{ fontSize: 14 }}>{formatCurrency(text) || GLOBAL_CONSTANTS.NA}</Text>,
    },
    {
        title: "Purpose",
        dataIndex: "purpose",
        key: "purpose",
        width: 150,
        render: (text) => <Text style={{ fontSize: 14 }}>{text || GLOBAL_CONSTANTS.NA}</Text>,
    },
    {
        title: "Transaction Remarks",
        dataIndex: "remarks",
        key: "remarks",
        width: 150,
        render: (text) => <Text style={{ fontSize: 14 }}>{text || GLOBAL_CONSTANTS.NA}</Text>,
    },
];

const SettlementTable = ({ selectedTab }) => {
    const { unassignTrans, loading } = useSelector((state) => state?.settlement);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedTab === "unassignTrans") {
            dispatch(getUnassignedTxn());
        } else {
            dispatch(getSettledDeals());
        }
    }, [dispatch, selectedTab]);

    const { columns, data } = useMemo(() => {
        if (selectedTab === "unassignTrans") {
            return { columns: unassignedCols, data: unassignTrans ?? [] };
        }
        return { columns: [], data: [] };
    }, [selectedTab, unassignTrans]);

    return (
        <Table
            columns={columns}
            dataSource={data}
            rowKey="utr"
            loading={loading}
            bordered
            scroll={{ x: "max-content" }}
            pagination={TABLE_PAGINATION}
            className="settlement-table"
        />
    );
};

export default SettlementTable;
